import { ValidatorFn, AsyncValidatorFn } from '@angular/forms';

/**
 * Validator registry
 * Maps validator keys to validator functions
 */
export class ValidatorRegistry {
  private static syncValidators: Map<string, (params?: any) => ValidatorFn> = new Map();
  private static asyncValidators: Map<string, (params?: any) => AsyncValidatorFn> = new Map();

  /**
   * Register sync validator factory
   */
  static registerSync(key: string, factory: (params?: any) => ValidatorFn): void {
    if (this.syncValidators.has(key)) {
      console.warn(`Sync validator "${key}" is already registered. Overwriting...`);
    }
    this.syncValidators.set(key, factory);
  }

  /**
   * Register async validator factory
   */
  static registerAsync(key: string, factory: (params?: any) => AsyncValidatorFn): void {
    if (this.asyncValidators.has(key)) {
      console.warn(`Async validator "${key}" is already registered. Overwriting...`);
    }
    this.asyncValidators.set(key, factory);
  }

  /**
   * Get sync validator
   */
  static getSync(key: string): ((params?: any) => ValidatorFn) | undefined {
    return this.syncValidators.get(key);
  }

  /**
   * Get async validator
   */
  static getAsync(key: string): ((params?: any) => AsyncValidatorFn) | undefined {
    return this.asyncValidators.get(key);
  }

  /**
   * Check if sync validator exists
   */
  static hasSync(key: string): boolean {
    return this.syncValidators.has(key);
  }

  /**
   * Check if async validator exists
   */
  static hasAsync(key: string): boolean {
    return this.asyncValidators.has(key);
  }

  /**
   * Get all registered sync validator keys
   */
  static getRegisteredSyncKeys(): string[] {
    return Array.from(this.syncValidators.keys());
  }

  /**
   * Get all registered async validator keys
   */
  static getRegisteredAsyncKeys(): string[] {
    return Array.from(this.asyncValidators.keys());
  }

  /**
   * Clear all registrations (useful for testing)
   */
  static clear(): void {
    this.syncValidators.clear();
    this.asyncValidators.clear();
  }

  /**
   * Initialize default validators (required, email, minLength, etc.)
   */
  static initializeDefaults(): void {
    // Default validators are initialized in sync-validators.ts and async-validators.ts
    // This method is reserved for future use
  }
}
